import { Empty } from '@/components/Empty';
import styles from './index.module.scss';
const Error404 = () => {
  return (
    <div className={styles.error404}>
      <Empty
        icon={require('@/images/common/icon_404.png')}
        title="您访问的页面不存在"
      />
    </div>
  );
};
export default Error404;
